import styled, {
  keyframes,
} from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const CalendarWorklogContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  flex: 0 0 62px;
  border-radius: 3px;
  border: 1px solid #e1e1e1;
  background: white;
  width: calc(100% - 14px);
  margin: 6px;
  cursor: pointer;
  animation: ${fadeIn} .3s ease-out forwards;
`;

export const CalendarWorklogBody = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
`;

export const CalendarWorklogBodyLeft = styled.div`
  flex: 1 1 100%;
  padding: 5px;
  display: flex;
  flex-flow: column nowrap;
`;

export const CalendarWorklogBodyRight = styled.div`
  display: flex;
  flex-flow: column nowrap;
  background: #f9f9f9;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #e1e1e1;
  > div:first-child {
    align-self: flex-start;
    margin-bottom: auto;
  }
`;

export const IssueKey = styled.div`
  border-radius: 2px;
  padding: 3.5px;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
  flex: 1 1 0%;
  background: ${(props) => {
    switch (props.type) {
      case 'automatic':
        return '#6fc1fb';
      case 'manual':
        return '#d89cdf';
      case 'mixed':
        return 'linear-gradient(135deg, #6fc1fb 0%, #6fc1fb 50%, #d89cdf 50%, #d89cdf 100%)';
      default:
        return '#666666';
    }
  }}
`;
export const WorklogInfo = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  flex: 0 0 30px;
  font-size: 12px;
`;

export const CounterBadge = styled.div`
  font-weight: bold;
  font-size: 10px;
  color: #172B4D;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border: 1px solid #172B4D;
  border-radius: 50%;
`;

CounterBadge.displayName = 'CounterBadge';

export const IssueSummary = styled.span`
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-style: normal;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -.16px;
    line-height: 20px;
    width: 500px;
`;

export const Edited = styled.span`
  margin-left: 5px;
  span {
    color: #de350b;
  }
`;
